import React, { useState, useEffect } from 'react';
import logo from '../../../assets/images/logo.png';

import rightArrowIcon from '../../../assets/images/right-arrow-icon.svg';
import DollarIcon from '../../../assets/images/dollar-icon.svg';

import './index.css';
import { Button, Col, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';

import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { DEV_API, SPORTS_CATEGORY, URL, WIN_POINT_RULES, WIN_POINT_RULES_1V1 } from '../../../const/index.js';
import SideMenu from '../../../components/SideMenu.js';
import { SPORT_ADD } from "../../../store/actionTypes.js";
import Template from "../Template.js"
import PaginationComponent from '../../../components/layouts/paginate.js'
import { getPlayerNames } from '../../index.js';

const ActiveSports = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const [team1Idx, setTeam1Idx] = useState(-1);
  const [sportCategory, setSportCategory] = useState('NFL');
  const [events, setEvents] = useState([]);
  const [playList, setPlayList] = useState({});

  const [selectedEvt, setSelectedEvt] = useState(null);
  const [event, setEvent] = useState(null);
  const [eventId, setEventId] = useState(-1);
  const [eventDate, setEventDate] = useState();

  const [primaryColor, setPrimaryColor] = useState('#0d6efd')
  const [secondaryColor, setSecondaryColor] = useState('white')

  const [totalItems, setTotalItems] = useState(1);
  const [page, setPage] = useState(1)

  useEffect(() => {
    axios.get(`${DEV_API}/api/games/many`, {
      params: {
        player: user._id,
        win: -1,
        page,
        limit: 10
      }
    }).then((response) => {
      const fetchedEvents = response.data.result || {};
      setEvents(fetchedEvents.games);
      setTotalItems(fetchedEvents.totalGames)
      setPage(fetchedEvents.currentPage)
    });
  }, [])

  // const handlePlayGame = (item) => {
  //   let apiUrl = URL[item.sportCategory];
  //   if (item.event != -1) {
  //     axios.get(apiUrl,
  //       {
  //         params: {
  //           event: item.event
  //         }
  //       }
  //     ).then((response) => {
  //       // setPlayList(response.data);
  //       let playList = response.data;
  //       let primaryColor, secondaryColor;
  //       if (playList?.boxscore?.teams && playList.boxscore.teams[item.selectedTeam]) {
  //         const primary_col = playList.boxscore.teams[item.selectedTeam].team.color;
  //         const secondary_col = playList.boxscore.teams[item.selectedTeam].team.alternateColor;

  //         primaryColor = primary_col.includes('#') ? primary_col : `#${primary_col}`;
  //         secondaryColor = secondary_col.includes('#') ? secondary_col : `#${secondary_col}`;
  //         // setPrimaryColor(primary_col.includes('#') ? primary_col : `#${primary_col}`);
  //         // setSecondaryColor(secondary_col.includes('#') ? secondary_col : `#${secondary_col}`);
  //       }

  //       dispatch({
  //         type: SPORT_ADD, payload: {
  //           sportCategory: item.sportCategory,
  //           eventId: item.event,
  //           team1Idx: item.selectedTeam,
  //           startPos: item.startPos || 0,
  //           eventDate: item.gameDate,
  //           payout: item.payout,
  //           playList,
  //           primaryColor,
  //           secondaryColor
  //         }
  //       })

  //       // var player1Name = "-";
  //       // var player2Name = "-";
  //       // var player3Name = "-";
  //       // var player4Name = "-";

  //       // if (item.startPos == 0) {
  //       //   player1Name = user.name
  //       // } else if (item.startPos == 1) {
  //       //   player2Name = user.name;
  //       // } else if (item.startPos == 2) {
  //       //   player3Name = user.name
  //       // } else if (item.startPos == 3) {
  //       //   player4Name = user.name
  //       // }

  //       const {name1, name2, name3, name4} = getPlayerNames(item.startPos, user.name, item.payout)

  //       const url = `/playGames?playerName=${user.name}&sportCategory=${item.sportCategory}&eventId=${item.event}&team1Idx=${item.selectedTeam}&startPos=${item.startPos}&isFree=${false}&point=${item.entryPoint}&payout=${item.payout}&primaryColor=${encodeURIComponent(primaryColor)}&secondaryColor=${encodeURIComponent(secondaryColor)}&player1Name=${name1}&player2Name=${name2}&player3Name=${name3}&player4Name=${name4}`;

  //       // Navigate using the URL with parameters
  //       navigate(url);
  //     })
  //   }
  // }

  const handlePlayGame = (item) => {
    let apiUrl = URL[item.sportCategory];
    if (item.event != -1) {
      axios.get(apiUrl, {
        params: { event: item.event }
      }).then((response) => {
        let playList = response.data;
        let primaryColor, secondaryColor;
        if (playList?.boxscore?.teams && playList.boxscore.teams[item.selectedTeam]) {
          const primary_col = playList.boxscore.teams[item.selectedTeam].team.color;
          const secondary_col = playList.boxscore.teams[item.selectedTeam].team.alternateColor;
          primaryColor = primary_col.includes('#') ? primary_col : `#${primary_col}`;
          secondaryColor = secondary_col.includes('#') ? secondary_col : `#${secondary_col}`;
        }

        dispatch({
          type: SPORT_ADD, payload: {
            sportCategory: item.sportCategory,
            eventId: item.event,
            team1Idx: item.selectedTeam,
            startPos: item.startPos || 0,
            eventDate: item.gameDate,
            point: item.entryPoint,
            payout: item.payout,
            playNames: item.playNames || [], // Ensure playNames is passed
            closetScorePair: item.closetScorePair || [],
            playList,
            primaryColor,
            secondaryColor,
            isFree: false, //This need to set for Paid game
            ...item
          }
        });

        // Navigate to /play and pass all info in state
        navigate('/play', {
          state: {
            sportCategory: item.sportCategory,
            eventId: item.event,
            team1Idx: item.selectedTeam,
            startPos: item.startPos || 0,
            eventDate: item.gameDate,
            point: item.entryPoint,
            payout: item.payout,
            playNames: item.playNames || [], // Ensure playNames is passed
            closetScorePair: item.closetScorePair || [],
            playList,
            primaryColor,
            secondaryColor,
            isFree: false, //This need to set for Paid game
            ...item
          }
        });
      });
    }
  }

  return (
    <>
      <Template>
        <div className='screen-2-section'>
          <div className='screen-2-content'>
            <div className='screen-top-part'>
              <div className='logo-part'>
                <Link to="/">
                  <img src={logo} alt="logo" className='img-fluid' />
                </Link>
              </div>
              <span className='screen-title'>Active <img src={DollarIcon} alt="" className='img-fluid' style={{ width: 30, height: 30 }} /> Games</span>
            </div>
            <div className='screen-2-centerpart'>
              {/* <span className='screen-purple-glow-title'>Pick a Game</span> */}
              <Row>
                <Col xs={5}></Col>
                <Col xs={4}><p className='text-white'>Entry Fee</p></Col>
                <Col xs={1}></Col>
                <Col xs={2}><p className='text-white'>Payout</p></Col>
                {events.map((item, index) => (
                  <>
                    <Col xs={5} key={index} aria-disabled="true">
                      <div className='screen-2-center-detail' onClick={() => handlePlayGame(item)}>
                        <img src={item.teams && item.teams[0].team.logo} alt="team 1" className='img-fluid' style={{ width: 30, height: 30 }} />
                        <span>vs</span>
                        <img src={item.teams && item.teams[1].team.logo} alt="team 2" className='img-fluid' style={{ width: 30, height: 30 }} />
                      </div>
                    </Col>
                    <Col xs={4}>
                      <p style={{ color: 'white', padding: '15px 0', fontSize: 20 }}>
                        $-{item.entryPoint}
                      </p>
                    </Col>
                    <Col xs={1}>
                      {/* <div className='py-3'>
                        <img src={rightArrowIcon} />
                      </div> */}
                    </Col>
                    <Col xs={2}>
                      <p style={{ color: 'white', padding: '15px 0', fontSize: 20 }}>
                        ${item.payout == 1 ? WIN_POINT_RULES[item.entryPoint] : WIN_POINT_RULES_1V1[item.entryPoint]}
                      </p>
                    </Col>
                  </>
                ))}
              </Row>
              <div className='d-flex justify-content-center'>
                <PaginationComponent
                  totalItems={totalItems}
                  itemsPerPage={5}
                  currentPage={page}
                  onPageChange={(number) => { setPage(number) }}
                />
              </div>
              <div className='screen-2-center-block'>
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
};

export default ActiveSports;
